import type { FragmentType } from '@packages/gql/generated/shopping';
import { type GetGlycerinServicesFragmentFragmentDoc } from '@packages/gql/generated/shopping/GetGlycerinServicesFragmentFragmentDoc';
import { unmask } from '@packages/gql/src/betterMasking';
import type { CurrencyCode, GlycerinService } from '@packages/tracking/src/types/types';

/* GraphQL */ `
  fragment GetGlycerinServicesFragment on APlus {
    clusters {
      label
      services {
        gratis
        name
        price
        preselected
        uuid
      }
    }
  }
`;

/* GraphQL */ `
  fragment GetGlycerinServicesCurrencyFragment on ProductPrice {
    currency
  }
`;

export type GetGlycerinServicesProps = {
  aplus: FragmentType<typeof GetGlycerinServicesFragmentFragmentDoc> | null | undefined;
  currency: CurrencyCode;
};

export const getGlycerinServices = ({ aplus, currency }: GetGlycerinServicesProps) => {
  if (!aplus) return { services: undefined };

  const { clusters } = unmask<typeof GetGlycerinServicesFragmentFragmentDoc>(aplus);

  if (clusters.length === 0) return { services: undefined };

  const services: GlycerinService[] = [];

  clusters.forEach((cluster) =>
    cluster?.services.forEach((service) => {
      services.push({
        currency,
        displayedPrice: service.gratis || !service.price ? 0 : Math.round(service.price * 100),
        serviceType: cluster.label,
        name: service.name || '',
        quantity: service.preselected ? 1 : 0,
        serviceId: service.uuid,
      });
    }),
  );

  return {
    services,
  };
};
